/* Global - Quantity input function */
/* -------------------------------------------------------------------------------------- */
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

document.addEventListener('DOMContentLoaded', () => {
	/* Global */
	/* -------------------------------------------------------------------------------------- */
	$('[js-open-item]').on('click', function(event) {
		event.preventDefault();
		var el = $(this),
		item = $(el.attr('data-open'));
		item.addClass('open');
		item.addClass('active');
		document.body.classList.add('popup-open'); // agregar
	});

	$('[js-close-item]').on('click', function(event) {
	    event.preventDefault();
	    /* Act on the event */
	    var el = $(this),
	      item = $(el.attr('data-close'));
	    item.removeClass('open');
	    item.removeClass('active');
		document.body.classList.remove('popup-open'); // agregar
        document.querySelector('body').style.overflow = 'auto'
	});

	$('[js-toggle-item]').on('click', function(event) {
	    event.preventDefault();
	    /* Act on the event */
	    var el = $(this),
	      item = $(el.attr('data-toggle'));
	    item.toggleClass('open');
	    item.toggleClass('active');
	    el.toggleClass('open');
	    el.toggleClass('active');
	});
	/* Menu */
	/* -------------------------------------------------------------------------------------- */
	$('[js-open-menu]').on('click', function(event) {
	    event.preventDefault();
	    /* Act on the event */
	    var el = $(this),
	      item = $(el.attr('data-open'));
	    item.addClass('open');
	});

	$('[js-close-menu]').on('click', function(event) {
	    event.preventDefault();
	    /* Act on the event */
	    var el = $(this),
	      item = $(el.attr('data-close'));
	    item.removeClass('open');
	    $('#menu-left').find('[js-menu-content]').removeClass('open');
	});

	$('[js-menu-child-level]').on('click', function(event) {
	    event.preventDefault();
	    /* Act on the event */
	    var el = $(this),
	      item = el.closest('[js-menu-content]');
	    item.addClass('open');
	});

	$('[js-menu-back-level]').on('click', function(event) {
	    event.preventDefault();
	    /* Act on the event */
	    var el = $(this),
	      item = el.closest('[js-menu-content]');
	    item.removeClass('open');
	});
});

window.addEventListener('load', (event) =>{
  $('[js-loader-section]').addClass('d-none');
});